import { useLoadScript } from '@react-google-maps/api';
import config from '../config/config';

const LIBRARIES = ['places'];

/**
 * Hook that loads the Google Maps JS SDK using the API key from config.
 * Returns { isLoaded, loadError } — gracefully returns false if key is missing.
 */
export const useGoogleMapsLoader = () => {
  const apiKey = config.GOOGLE_MAPS_API_KEY || '';

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: apiKey,
    libraries: LIBRARIES,
    preventGoogleFontsLoading: false,
  });

  if (!apiKey) {
    return { isLoaded: false, loadError: null };
  }

  return { isLoaded, loadError };
};
